export class CreateApiCredentialsResponse {
    'apiCredentialsProperties';
    'clientSecret';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "apiCredentialsProperties",
            "baseName": "apiCredentialsProperties",
            "type": "ApiCredentialsProperties",
            "format": ""
        },
        {
            "name": "clientSecret",
            "baseName": "clientSecret",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateApiCredentialsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
